import React, {Component} from "react";
import PropTypes from 'prop-types';

export default class Expander extends Component {
    state = {
        closed: false
    };

    toggleClosed = () => {
        this.setState({closed: !this.state.closed})
    };

    componentDidMount() {
        if (this.props.startClosed) this.setState({closed: true})
    }

    render() {
        let [header, items] = this.props.children;
        if (!React.isValidElement(header) || !React.isValidElement(items)) throw new Error("Must have two children");
        const headerProps = {
            ...header.props,
            onClick: this.toggleClosed
        };
        header = React.cloneElement(header, headerProps);

        return (
            <div className={`${this.props.className ? this.props.className : ""} ${this.state.closed ? this.props.closedClassName : ""}`} onMouseDown={event => event.stopPropagation()}>
                {header}
                {!this.state.closed && items}
            </div>
        );
    }

}

Expander.propTypes = {
    children: PropTypes.node.isRequired,
    startClosed: PropTypes.bool,
    className: PropTypes.string,
    closedClassName: PropTypes.string
};